import React, { useContext } from 'react'
import * as R from 'ramda'

export const OrderDetailsSettings = {
  'item.show_full_price': 'Show full price (qty * item price)',
  'items.min.quantity': 'Always show item quantity',
  'items.menu.name': 'Show menu name',
  'items.menu.category': 'Show category name',
  'items.alias': 'Use item aliases',
  'modifiers.min.quantity': 'Always show option quantity',
  'modifiers.group.name': 'Show modifier name',
}
export interface UserConfig {
  // fullItemNames: boolean
  // showQuantity: boolean // Show quantity even is 1
  getConfig: (path: string) => boolean | string | number
  setConfig: (path: string, value: string | boolean | number) => void
}

export const UserConfigCtx = React.createContext<UserConfig | null>(null)
export const StackCtx = React.createContext<any | null>(null)

export const LensPath = (
  lens: R.Lens,
  ctx: React.Context<any>,
  displayName: string,
  transformer?: <T>(a: T) => string
) => {
  const fn = function() {
    const data = useContext(ctx)
    return <>{transformer ? transformer(R.view(lens, data)) : R.view(lens, data)}</>
  }
  fn.displayName = displayName
  return fn
}

export const LensPath2 = (
  lens: R.Lens,
  ctx: React.Context<any>,
  ctx2: React.Context<any>,
  displayName: string,
  transformer?: (data: any, additional: any) => string
) => {
  const fn = function() {
    const data = useContext(ctx)
    const additional = useContext<any>(ctx2)
    return <>{transformer ? transformer(R.view(lens, data), additional) : R.view(lens, data)}</>
  }
  fn.displayName = displayName
  return fn
}

export const LensPath3 = (
  lens: R.Lens,
  ctx: React.Context<any>,
  ctx2: React.Context<any>,
  ctx3: React.Context<any>,
  displayName: string,
  transformer?: (data: any, extra1: any, extra2: any, extra3: any) => string
) => {
  const fn = function() {
    const data = useContext(ctx)
    const extra2 = useContext<any>(ctx2)
    const extra3 = useContext<any>(ctx3)
    return <>{transformer ? transformer(R.view(lens, data), data, extra2, extra3) : R.view(lens, data)}</>
  }
  fn.displayName = displayName
  return fn
}

export const CondLensPath = (cond: (a: any) => boolean, lens: R.Lens, ctx: React.Context<any>, displayName: string) => {
  const fn = function(props: { children: any }) {
    const data = useContext(ctx)
    if (cond(R.view(lens, data))) {
      return props.children
    } else {
      return null
    }
  }
  fn.displayName = displayName
  return fn
}
